import { Box } from '@mui/material';
import { Asset, SecurityInventoryCategory } from '@x-guard/xgac-types/xgac';
import { useEffect, useState } from 'react';
import { useTranslate } from 'react-admin';
import TuneIcon from '@mui/icons-material/Tune';
import { InventoryCategoryIconName } from '../../../components/icons/inventoryCategoryIcons';
import { FilterSelector } from './FilterSelector';

export const FilterButton = (props: {
  children: React.ReactNode;
  categories: SecurityInventoryCategory[];
  selectedCategory: string | null;
  setSelectedCategory: React.Dispatch<React.SetStateAction<string | null>>;
  users: Asset[];
  selectedUser: string | null;
  setSelectedUser: React.Dispatch<React.SetStateAction<string | null>>;
}) => {

  const translate = useTranslate();
  const [filterOpen, setFilterOpen] = useState(false);
  const [draftCategory, setDraftCategory] = useState<string | null>(props.selectedCategory);
  const [draftUser, setDraftUser] = useState<string | null>(props.selectedUser);

  useEffect(() => {

    if (filterOpen) {

      setDraftCategory(props.selectedCategory);
      setDraftUser(props.selectedUser);

    }

  }, [filterOpen, props.selectedCategory, props.selectedUser]);

  const hasFilters = props.selectedCategory != null || props.selectedUser != null;

  return (
    <Box sx={{
      position: 'relative',
      width: '100%',
    }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
        {/* This ensures that the search bar and filter are in the same row, but
        when the filter is opened its pop-up is full-width */}
        <Box sx={{ flex: '1 1 60%', minWidth: 0 }}>
          {props.children}
        </Box>
        <Box sx={{ flex: '0 0 40%', minWidth: 0 }}>
          <button
            type="button"
            className={hasFilters ? 'filter-items-button filter-items-button-active' : 'filter-items-button'}
            onClick={() => setFilterOpen(!filterOpen)}
          >
            <TuneIcon />
            <span>
              {translate(hasFilters ? 'general.text.filtered' : 'general.text.filter')}
            </span>
          </button>
        </Box>
      </Box>
      {filterOpen && (
        <div className="device-filter-div">
          <div className="device-filter-div-inner">
            <Box sx={{ px: 1.25, py: 1.25 }}>
              <FilterSelector
                label={translate('resources.security-inventory-categories.name', { smart_count: 1, _: 'Category' })}
                items={props.categories.map((category) => ({
                  name: category.name,
                  _id: category._id,
                  icon: category.icon as InventoryCategoryIconName,
                }))}
                value={draftCategory}
                onChange={setDraftCategory}
              />
              <FilterSelector
                label={translate('resources.app-users.name', { smart_count: 1, _: 'User' })}
                items={props.users.map((user) => ({
                  name: user.name,
                  _id: user._id,
                }))}
                value={draftUser}
                onChange={setDraftUser}
              />
            </Box>
            <div className="device-filter-buttons">
              <button
                type="button"
                onClick={() => {

                  setDraftCategory(null);
                  setDraftUser(null);
                  props.setSelectedCategory(null);
                  props.setSelectedUser(null);
                  setFilterOpen(false);

                }}
              >
                {translate('resources.buttons.text.remove_filters')}
              </button>
              <button
                type="button"
                onClick={() => {

                  props.setSelectedCategory(draftCategory);
                  props.setSelectedUser(draftUser);
                  setFilterOpen(false);

                }}
              >
                {translate('resources.buttons.text.save_filters')}
              </button>
            </div>
          </div>
        </div>
      )}
    </Box>
  );

};
